export default {
  nav: {
    search: 'Поиск Steam, PlayStation, Xbox...',
    cart: 'Корзина',
  },
  hero: {
    s1: {
      platform: 'PlayStation Store',
      title: 'Пополни баланс за пару минут',
      desc: 'Карты номиналом от $5 до $100. Мгновенная доставка на email.',
      cta: 'Выбрать карту',
    },
    s2: {
      platform: 'Steam Wallet',
      title: 'Игры, DLC и внутриигровые предметы',
      desc: 'Пополнение кошелька Steam. Работает для всех регионов.',
      cta: 'Пополнить Steam',
    },
    s3: {
      platform: 'Xbox Game Pass',
      title: 'Ultimate по выгодной цене',
      desc: '100+ игр, EA Play и облачный гейминг в одной подписке.',
      cta: 'Купить подписку',
    },
    stats: [
      { value: '15 000+', label: 'Довольных клиентов' },
      { value: '< 5 мин', label: 'Время доставки' },
      { value: '99.8%',   label: 'Успешных оплат' },
      { value: '24/7',    label: 'Поддержка' },
    ],
  },
  categories: {
    all:         'Все',
    steam:       'Steam',
    playstation: 'PlayStation',
    xbox:        'Xbox',
    roblox:      'Roblox',
    fortnite:    'Fortnite',
    minecraft:   'Minecraft',
    gta:         'GTA Online',
  },
  badges: {
    hit:     'Хит',
    new:     'Новинка',
    sale:    'Акция',
    popular: 'Популярное',
    deal:    'Выгодно',
  },
  sort: {
    label:     'Сортировка:',
    popular:   'Популярные',
    priceAsc:  'Цена ↑',
    priceDesc: 'Цена ↓',
  },
  catalog: {
    title: 'Каталог',
    count: '{n} товаров',
    empty: {
      title: 'Ничего не найдено',
      desc:  'Попробуйте другой запрос или категорию',
      reset: 'Сбросить фильтры',
    },
  },
  cta: {
    title: 'Нужна помощь с выбором?',
    desc:  'Наша поддержка онлайн 24/7 и поможет подобрать нужный номинал',
    btn:   'Telegram',
  },
  cart: {
    title: 'Корзина',
    empty: {
      title: 'Корзина пуста',
      desc:  'Добавьте товары из каталога',
      btn:   'Перейти в каталог',
    },
    promo:    'Промокод',
    promoBtn: 'Применить',
    total:    'Итого',
    checkout: 'Оплатить',
    footer:   'Безопасная оплата · Мгновенная доставка',
  },
  accountForm: {
    title:    'Данные для доставки',
    subtitle: 'Укажите аккаунт(ы), на которые нужно зачислить покупку',
    email:    { label: 'Email для квитанции', placeholder: 'адрес электронной почты' },
    continue: 'Перейти к оплате',
    required: 'Пожалуйста, заполните все поля',
    fields: {
      steam:       { label: 'Steam логин',        placeholder: 'Имя пользователя или ссылка на профиль' },
      playstation: { label: 'PSN ID',              placeholder: 'Ваш ник в PSN' },
      xbox:        { label: 'Xbox Gamertag',        placeholder: 'Ваш Xbox gamertag' },
      roblox:      { label: 'Roblox Username',      placeholder: 'Ваш ник в Roblox' },
      fortnite:    { label: 'Epic Games Email',     placeholder: 'адрес электронной почты' },
      minecraft:   { label: 'Minecraft Username',   placeholder: 'Ваш ник в Minecraft' },
      gta:         { label: 'Rockstar аккаунт',     placeholder: 'Email или имя в Social Club' },
    },
  },
  success: {
    title:    'Оплата прошла успешно!',
    subtitle: 'Ваш заказ оплачен',
    desc:     'Пополнение будет зачислено на ваш аккаунт в течение нескольких минут. Квитанция отправлена на email.',
    close:    'Отлично, спасибо!',
  },
  payment: {
    title:   'Безопасная оплата',
    loading: 'Инициализация платежа…',
    error:   'Ошибка оплаты',
    retry:   'Попробовать снова',
    close:   'Закрыть',
  },
  howItWorks: {
    title: 'Как это работает',
    steps: [
      { icon: 'search', title: 'Выбери товар',        desc: 'Просмотри каталог и выбери нужное пополнение или подарочную карту' },
      { icon: 'pay',    title: 'Оплати безопасно',     desc: 'Оформи заказ за несколько секунд через зашифрованный платёжный виджет' },
      { icon: 'email',  title: 'Получи мгновенно',     desc: 'Код или подтверждение пополнения придёт на твой email в течение минуты' },
    ],
  },
  modal: {
    addToCart: 'В корзину',
    buyNow:    'Купить сейчас',
    includes:  'Что входит',
    region:    'Регион',
    delivery:  'Мгновенная доставка после оплаты',
  },
  products: {
    p1:  { description: 'Пополни Steam Wallet на $5 и трать на игры, DLC и внутриигровые предметы из всего каталога Steam.', features: ['Мгновенная доставка на аккаунт', 'Работает для всех игр и DLC', 'Совместим с CS2, Dota 2 и другими', 'Без срока действия'] },
    p2:  { description: 'Самое популярное пополнение Steam. $10 открывают тысячи игр в каталоге по выгодной цене.', features: ['Мгновенная доставка на аккаунт', 'Работает для всех игр и DLC', 'Совместим с CS2, Dota 2 и другими', 'Без срока действия'] },
    p3:  { description: 'Пополни кошелёк Steam на $20 и получи доступ к более широкому выбору игр, сезонных пропусков и предметов.', features: ['Мгновенная доставка на аккаунт', 'Работает для всех игр и DLC', 'Совместим с CS2, Dota 2 и другими', 'Без срока действия'] },
    p4:  { description: 'Пополни PSN-кошелёк на $10 и открой сотни игр, фильмов и дополнений для PS4 и PS5.', features: ['Мгновенное пополнение PSN', 'Работает на PS4 и PS5', 'Покупай игры, DLC, PS Plus и другое', 'Регион: Глобальный'] },
    p5:  { description: 'Получи $25 для PlayStation Network со скидкой. Идеально для новых AAA-релизов или покупки PS Plus.', features: ['Мгновенное пополнение PSN', 'Работает на PS4 и PS5', 'Покупай игры, DLC, PS Plus и другое', 'Регион: Глобальный'] },
    p6:  { description: 'PlayStation Plus Essential — бесплатные игры каждый месяц, онлайн-мультиплеер и эксклюзивные скидки в PS Store.', features: ['Доступ к онлайн-мультиплееру', '2–3 бесплатные игры каждый месяц', 'Эксклюзивные скидки в PS Store', 'Облачное хранилище для сохранений'] },
    p7:  { description: 'Пополни Microsoft-аккаунт на $10 и трать на игры Xbox, DLC и подписки из Microsoft Store.', features: ['Работает на Xbox и ПК (Microsoft Store)', 'Покупай игры, фильмы и приложения', 'Засчитывается в Xbox Game Pass', 'Без срока действия'] },
    p8:  { description: 'Xbox Game Pass Ultimate — 100+ игр, подписка EA Play и облачный гейминг Xbox в одном пакете.', features: ['100+ игр на консоли и ПК', 'EA Play включён без доплаты', 'Xbox Cloud Gaming — играй где угодно', 'Новые игры Xbox в день выхода'] },
    p9:  { description: 'Robux — внутриигровая валюта Roblox. 800 Robux пойдут на предметы для аватара, игровые пропуска и апгрейды.', features: ['Мгновенное зачисление на аккаунт', 'Работает в любой игре Roblox', 'Покупай аксессуары и одежду для аватара', 'Улучшай игровые пропуска'] },
    p10: { description: 'Получи 2000 Robux по выгодной цене и открой редкие предметы, эксклюзивные пропуска и многое другое.', features: ['Мгновенное зачисление на аккаунт', 'Работает в любой игре Roblox', 'Покупай аксессуары и одежду для аватара', 'Улучшай игровые пропуска'] },
    p11: { description: 'V-Bucks — валюта Fortnite. 1000 V-Bucks хватит на скины, эмоции, кирки и Боевой пропуск.', features: ['Работает на ПК, PS4/5, Xbox, Switch и Mobile', 'Покупай образы, эмоции и расцветки', 'Открой Боевой пропуск', 'Без срока действия'] },
    p12: { description: 'Запасись 2800 V-Bucks и бери сразу несколько наборов, скинов и полный Боевой пропуск — ещё и останется.', features: ['Работает на ПК, PS4/5, Xbox, Switch и Mobile', 'Покупай образы, эмоции и расцветки', 'Открой Боевой пропуск', 'Без срока действия'] },
    p13: { description: 'Оригинальный Minecraft Java Edition — строй, исследуй и выживай в бесконечных мирах. Поддержка модов и мультиплеера.', features: ['Постоянная лицензия на полную игру', 'Все будущие обновления включены', 'Тысячи модов от сообщества', 'Мультиплеер на публичных и приватных серверах'] },
    p14: { description: 'Карточка «Бычья акула» добавляет $1 000 000 GTA$ на твой аккаунт в GTA Online — машины, оружие и недвижимость.', features: ['$1 000 000 GTA$ зачисляется сразу', 'Доступно на PS4, PS5, Xbox и ПК', 'Покупай авто, квартиры и оружие', 'Без ограничений по времени'] },
    p15: { description: 'Карточка «Мегалодон» — $8 000 000 GTA$: хватит на суперкары, яхту и роскошный пентхаус в Лос-Сантосе.', features: ['$8 000 000 GTA$ зачисляется сразу', 'Доступно на PS4, PS5, Xbox и ПК', 'Самая выгодная карточка акулы', 'Без ограничений по времени'] },
  },
  footer: {
    desc: 'Моментальное пополнение аккаунтов Steam, PlayStation, Xbox и других платформ.',
    cols: [
      { title: 'Каталог',      items: ['Steam', 'PlayStation', 'Xbox', 'Roblox', 'Fortnite'] },
      { title: 'Информация',   items: ['Как это работает', 'Гарантии', 'Отзывы', 'Блог'] },
      { title: 'Поддержка',    items: ['FAQ', 'Связаться с нами', 'Политика возврата', 'Пользовательское соглашение'] },
    ],
    rights: '© 2025 GamePay. Все права защищены.',
  },
}
